import React from 'react';

import ImgIconComp from '../../imgcomp';
import { withTranslation } from 'react-i18next';
import { Modal, ThemeProvider, ModalContent, Checkbox, Notification, Button } from '@workboard/wobo-ui';
import styled from "styled-components";

const StyledModal = styled(Modal)`
  ${ModalContent} { 
    padding: 0px !important;
  }
`;
const StyledCheckbox = styled(Checkbox)`
.MuiButtonBase-root {
	width: 24px;
	height: 24px;
}
svg {
	width: 24px;
	height: 24px;

  }


`;
const LoaderComp = function (props) {
    return (<div className="loading-comp"><ImgIconComp id="loadinggif" /></div>);
};

const separatorSymbol = ' • ';

const ModalExportContent = React.forwardRef((props, ref) => {
    const {items, dataLoading} = props;
    return (
        <span ref={ref}>
        {dataLoading ? <LoaderComp /> : 
        <div className="okr-modal-content">
            {items}
        </div>
        }
        </span>
    )
});

export default withTranslation()( class OKRExcelExportModal extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            popupOpen: true,
            dataLoading: true,
            items: [],
            dates: '',
            includeRelationships: false,
            selectedItems: [],
            notifOpen: false,
            severity: '',
            message:'',
            showCountExceeded: false,
            userEmail: [],
            count: 0,
            disableExport: false,
            useBG: false
        };

        this.closeModal = this.closeModal.bind(this);
        this.download =  this.download.bind(this);
        this.toggleSelectedItem = this.toggleSelectedItem.bind(this);
        this.ref = React.createRef();
        this.enterUserMail = this.enterUserMail.bind(this);
    }

    modelFooter = (data) => {
        const { t } = this.props;
        return (
          <div>
          {
            <div className={'custom-model-footer'}>
                <Button variant="ghost" data-testid="goback-button" onClick={data.onDismiss}>
                {t('Cancel')}
                </Button> &nbsp;
                <Button variant="primary"  data-testid="add-button" onClick={data.onSubmit} isDisabled={data.disableExport}>
                {t('Export')}
                </Button>
            </div>
         }
        </div>
        )
      }

    // Lifecycle methods

    componentDidMount() {

        $.ajax({
            type: 'GET',
            url: wbConfig.baseUrl + '/exportToSpreadsheet/getSelectedItems',
            encode: true,
            success: data => {
                this.setState({dataLoading: false});
              },
              error: (xhr, ajaxOptions, thrownError) => {
                this.setState({dataLoading: false});
                console.log(xhr.responseText);
              } 
        })

        .done(response => {

            let items = [];

            if (response['selectedItems'].length !== null && 
                response['selectedItems'].length > 0 
                ) {

                if (response['startDate'] && 
                    response['endDate']) {
                        const { t } = this.props;
                        const dateStart = moment(response['startDate'], "MM/DD/YYYY").format("MMM DD, YYYY");
                        const dateEnd = moment(response['endDate'], "MM/DD/YYYY").format("MMM DD, YYYY");
                        this.setState({
                            dates: ` ${t('for')} ` + dateStart + ` ${t('to')} ` + dateEnd
                        });
                }

                response['selectedItems'].forEach(item => {
                  items.push({
                    type: item['type'],
                    name: item['name'],
                    id: item['id'],
                    owner: this.formatOwner(item),
                    value: item['type'] + '-' + item['id'],
                  });
                });

                this.setState({items});
                this.setState({showCountExceeded : response['useBG'], useBG : response['useBG']});
              }
        })

        // this.disableScroll();
    }

    componentWillUnmount() {
        // this.enableScroll();
    }

    // Event handlers

    disableScroll() {
        // Get the current scroll position
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  
        // if any scroll is attempted, set this to the previous value 
        window.onscroll = function() { 
            window.scrollTo(scrollLeft, scrollTop); 
        }; 
    } 

    enableScroll() { 
        window.onscroll = () => {}; 
    }

    closeModal() {
        this.setState({popupOpen:false});
    }

    // Helper methods

    formatOwner(item) {
      switch (item['type']) {
        case 'team': 
          return [item['owner']];

        case 'goal':
          return [item['teamOwner'], item['teamName']]

        case 'user':
        default:
          return []
      }
    }

    // Actions          

    download() {
        const { t } = this.props;
        let selectedItem = (this.state.selectedItems[0])?this.state.selectedItems[0]:false;
        let selectedItemFlag = (selectedItem && (
           selectedItem .includes('team') || selectedItem .includes('user')))?true:false
        if ((selectedItemFlag && this.state.showCountExceeded) || this.state.useBG) {
            let url = wbConfig.baseUrl + '/exportToSpreadsheet/okrExport';
            const payload = {
                includeKRRelationships: (this.state.includeRelationships ? 1 : 0),
                selectedItems: this.state.selectedItems.join(),
                userEmail: this.state.userEmail.length > 0 ? this.state.userEmail.pop(): '',
                useBG: this.state.useBG
            };
            $.ajax({
                type: 'POST',
                url: url,
                data: payload,
                encode: true,
                success: _data => {
                    this.setState({dataLoading: false,
                         notifOpen: true,
                         severity: 'success',
                         message:t('Export delivered to your email and any email address entered.')
                    });
                    setTimeout(() => {
                        this.closeModal();
                    }, 3000);

                  },
                  error: (_xhr, _ajaxOptions, _thrownError) => {
                    this.setState({dataLoading: false,
                        notifOpen: true,
                        severity: 'error',
                        message:`${t('The email could not be sent')}. ${t('Please try again later.')}`
                    });
                    setTimeout(() => {
                        this.closeModal();
                    }, 3000);

                  } 
            });
        }else{
            let url = wbConfig.baseUrl + '/exportToSpreadsheet/okrExport?includeKRRelationships=';
            url += (this.state.includeRelationships ? 1 : 0);
            url += '&selectedItems=' + this.state.selectedItems.join();
            this.closeModal();
            window.open(url, '_blank');
        }
    }

    toggleSelectedItem(item, checked) {
        const { t } = this.props;
        let selectedItem = item.value;
        if (checked) {
            if (this.state.selectedItems.indexOf(selectedItem) === -1) {
                this.state.selectedItems.push(selectedItem);
            }
            //Ajax call to check count
            if(!this.state.showCountExceeded && !this.state.useBG){
                let url = wbConfig.baseUrl + '/exportToSpreadsheet/getExcelKrCount?selectedItems=';
                this.setState({disableExport:true});
                $.ajax({
                    type: 'GET',
                    url: url + this.state.selectedItems.slice(-1),
                    encode: true,
                    success: countData => {
                        console.log(countData);
                        if(countData) {
                            this.setState(prevState => ({ count: Number(countData) + Number(prevState.count)}));
                            if (this.state.count > 2500) {
                                this.setState({showCountExceeded: true});
                            } else {
                                this.setState({showCountExceeded: false});
                            }
                        }
                        this.setState({disableExport:false});
                    },
                    error: (_xhr, _ajaxOptions, _thrownError) => {
                        this.setState({dataLoading: false,
                            notifOpen: true,
                            severity: 'error',
                            message:`${t('Error fetching count.')} ${t('Please try again later.')}`,
                            disableExport:false
                        });
                        setTimeout(() => {
                            this.closeModal();
                        }, 3000);
                    }
                });
            }
        } else {
            this.state.selectedItems = this.state.selectedItems.filter(function(item) {return item !== selectedItem});
            this.setState({showCountExceeded: false});
        }
    }

    enterUserMail(event) {
        let enteredMail = event.target.value;
        if(enteredMail.length > 0) {
            this.state.userEmail.push(enteredMail);
        }
    }
    // View

    render(){
        const { t } = this.props;
        let itemsList = [];
        let i = 0;

        for (const item of this.state.items) {
            let checkbox = <></>;

            if (['user', 'team'].includes(item.type)) {
                checkbox =<div className={"export-excel-org-checkbox"}>
                  
                        <StyledCheckbox 
                                     id={"selectItem-" + item.value} 
                                     label={t("Include all teams in the organizational tree of the team leader")} 
                                     onChange={e => this.toggleSelectedItem(item, e.target.checked)}
                                      />
                        </div>
              
                        
            
            }

            let owner = <></>;
            if (item.owner.length > 0) {
               owner = <div className="kri-owner">{item.owner.join(separatorSymbol)}</div>
            }

            itemsList.push(
                <div className="key-results-item" 
                     key={item.type + i}>
                    <div className="kri-title">
                        <div className="kri-name">{item.name}</div>
                        {owner}
                    </div>
                    {checkbox}
                </div>
            )

            i++;
        }

        return (
            <ThemeProvider>
            <StyledModal
            isOpen={this.state.popupOpen}
            dismissLabel={t("Cancel")}
            onDismiss={this.closeModal}
            onSubmit={this.download}
            submitLabel={t("Export")}
            title={t("Export Key Results to Excel")}
            disableExport={this.state.disableExport}
            actions={this.modelFooter}
            >
            <div id={"export-OKR-popup"} className={"export-excel-okr"}>
                <div className="popupContent" >
                    <div className="contentWrap">
                        <div className="includeBlock">
                            {
                            <div className="fieldcontent export-excel-relation-checkbox">
                                {/* <CheckBoxComp id="includeKeyResultRelationships"
                                    label={`Include ${t('key result')} relationships`}
                                    classDefined={"inputLabel font14px"} 
                                    onChange={e => this.setState({includeRelationships: e.target.checked})}
                                    checkboxProps={{checked: this.state.includeRelationships, disabled: false}}/>
                                     */}
                                     <StyledCheckbox 
                                     id="includeKeyResultRelationships"
                                     isChecked={this.state.includeRelationships}  
                                     label={`${t('Include key result relationships')}`}
                                     onChange={e => this.setState({includeRelationships: e.target.checked})}
                                      />
                            </div>
                            }

                            <div className="selectedItemsWrap">
                                {itemsList && itemsList.length > 0 &&
                                    <div className="selectedItemsTitle">{t('Selected item')}(s){this.state.dates}:</div>
                                }
                                <ModalExportContent
                                    items = {itemsList}
                                    ref = {this.ref}
                                    dataLoading ={this.state.dataLoading}
                                />
                            </div>
                            <div className="exportNote">
                            {t('Excel export will not include OKR comments or information about workstreams.')}
                            </div>
                            { this.state.showCountExceeded  ?
                            <div className="publisher-send-email-popup">
                                <div>
                                <input className="send-email-textbox" onChange={this.enterUserMail} type="text" name="emails" placeholder={t("Enter email address (optional)")} />
                                </div>
                                <div className="exportNote">
                                {`${t('This Excel export potentially exceeds the maximum record limit.')} ${t('If it exceeds, the export will be sent to your email and any email address entered above.')} ${t('Otherwise, the export will download to your local files.')}`}
                                </div>
                            </div> : '' }                        
                        </div>
                    </div>
                </div>  
            </div>
            { this.state.notifOpen && 
                <Notification
                    open={true}
                    severity={this.state.severity}
                    message={this.state.message}
                    anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
                    onClose={() => this.setState({
                        notifOpen: false,
                        severity: '',
                        message:''
                    })}
                />
            }      
        </StyledModal>
       
        </ThemeProvider>
        )
    }
});